import React from 'react';
import { Card, CardContent } from '../ui/card';
import {
  Buildings,
  Users,
  FileText,
  CurrencyDollar,
  NavigationArrow,
} from '@phosphor-icons/react';

const SummaryCard = ({ icon: Icon, iconColor, iconBg, label, value, subtext, testid }) => (
  <Card className="border-slate-200" data-testid={testid}>
    <CardContent className="pt-4">
      <div className="flex items-center gap-3">
        <div className={`p-2 ${iconBg} rounded-lg`}>
          <Icon size={20} className={iconColor} />
        </div>
        <div>
          <p className="text-xs text-slate-500">{label}</p>
          <p className="text-xl font-bold">{value}</p>
          {subtext && <p className="text-xs text-green-600">{subtext}</p>}
        </div>
      </div>
    </CardContent>
  </Card>
);

const CrossAgencySummaryCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
    <SummaryCard
      icon={Buildings}
      iconColor="text-indigo-600"
      iconBg="bg-indigo-100"
      label="Agencies"
      value={stats.total_agencies}
      subtext={`${stats.active_agencies} active`}
      testid="ca-stat-agencies"
    />
    <SummaryCard
      icon={Users}
      iconColor="text-blue-600"
      iconBg="bg-blue-100"
      label="Patients"
      value={(stats.total_patients || 0).toLocaleString()}
      testid="ca-stat-patients"
    />
    <SummaryCard
      icon={Users}
      iconColor="text-purple-600"
      iconBg="bg-purple-100"
      label="Employees"
      value={(stats.total_employees || 0).toLocaleString()}
      testid="ca-stat-employees"
    />
    <SummaryCard
      icon={FileText}
      iconColor="text-amber-600"
      iconBg="bg-amber-100"
      label="Claims"
      value={(stats.total_claims || 0).toLocaleString()}
      testid="ca-stat-claims"
    />
    <SummaryCard
      icon={CurrencyDollar}
      iconColor="text-green-600"
      iconBg="bg-green-100"
      label="Billed"
      value={`$${(stats.total_billed || 0).toLocaleString()}`}
      testid="ca-stat-billed"
    />
    <SummaryCard
      icon={NavigationArrow}
      iconColor="text-emerald-600"
      iconBg="bg-emerald-100"
      label="EVV Visits"
      value={(stats.total_evv_visits || 0).toLocaleString()}
      testid="ca-stat-evv"
    />
  </div>
);

export default CrossAgencySummaryCards;
